var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.786621,
    y: 0.532227,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F46940"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9328 8.3024C18.1916 8.53242 18.2149 8.92867 17.9848 9.18745L11.2978 16.7103C11.1789 16.8441 11.0084 16.9207 10.8293 16.9207C10.6502 16.9207 10.4797 16.8441 10.3607 16.7103L7.01724 12.9489C6.78722 12.6901 6.81053 12.2939 7.06931 12.0638C7.32808 11.8338 7.72433 11.8571 7.95435 12.1159L10.8293 15.3502L17.0477 8.35446C17.2778 8.09569 17.674 8.07238 17.9328 8.3024Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconActive);
export default __webpack_public_path__ + "static/media/checkIconActive.dda4b8d5a71a8e652a69c6a9e2220ea1.svg";
export { ForwardRef as ReactComponent };